import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import * as bulkEditDiscountsDrawer from './BulkEditDiscountsDrawer';
import * as bulkEditEstimatorModal from './BulkEditEstimatorModal';
import * as bulkEditProfitItemsDrawer from './BulkEditProfitItemsDrawer';
import * as bulkEditQuantitiesDrawer from './BulkEditQuantitiesDrawer';
import * as bulkUpdateWorkflowStatusModal from './BulkUpdateWorkflowStatusModal';
import quoteItemNavReducer from './data/reducer';
import quoteItemNavSaga from './data/sagas';
import deepCopyInPlaceReducer from './deepCopyInPlaceModal/data/reducer';
import deepCopyInPlaceSaga from './deepCopyInPlaceModal/data/sagas';
import deepCopyReducer from './deepCopyModal/data/reducer';
import deepCopySaga from './deepCopyModal/data/sagas';

const reducer = combineReducers({
  nav: quoteItemNavReducer,
  deepCopyModal: deepCopyReducer,
  deepCopyInPlaceModal: deepCopyInPlaceReducer,
  bulkEditDiscountsDrawer: bulkEditDiscountsDrawer.reducer,
  bulkEditEstimatorModal: bulkEditEstimatorModal.reducer,
  bulkEditProfitItemsDrawer: bulkEditProfitItemsDrawer.reducer,
  bulkEditQuantitiesDrawer: bulkEditQuantitiesDrawer.reducer,
  bulkUpdateWorkflowStatusModal: bulkUpdateWorkflowStatusModal.reducer,
});

const saga = function* () {
  yield all([
    deepCopySaga(),
    deepCopyInPlaceSaga(),
    quoteItemNavSaga(),
    bulkUpdateWorkflowStatusModal.saga(),
  ]);
};

export default { reducer, saga };
